/*
 * @Description: 页面详情接口
 * @Author: henry
 * @Date: 2025-04-19 16:39:21
 * @LastEditors: henry
 * @LastEditTime: 2025-04-22 15:38:02
 */

import http from '@/mm/http.js'
export const templateInfoApi = (params, loading = true) => {
    return http({
        url: '/api/template/page/info',
        method: 'get',
        loading: loading,
        params
    })
}

export const pageInfoApi = (params, loading = true) => {
    return http({
        url: '/api/page/info',
        method: 'get',
        loading: loading,
        params
    })
}